export default __webpack_public_path__ + "static/315-128eff5a43effdcd00c61c6d6a947d5b.gif";